// Shared e-mail text building: used by both the Mallid editor preview and the
// Raport modal, so what you preview is exactly what gets sent.

export const TEMPLATE_KEYS = ["tavaklient", "uus_klient"];

// Fallback if the templates can't be loaded — sending must never break.
export const DEFAULT_TEMPLATES = [
  {
    key: "tavaklient",
    name: "Tavaklient",
    intro: "Tere,\n\nEdastame veoselehtede koondaruande perioodi {periood} kohta.",
    closing: "Täpsem aruanne on lisatud Exceli failina.\n\nTervitades,\nBioforce",
  },
  {
    key: "uus_klient",
    name: "Uus klient",
    intro:
      "Tere,\n\nTere tulemast! Edastame Teile esimese veoselehtede koondaruande perioodi {periood} kohta.",
    closing:
      "Täpsem aruanne on lisatud Exceli failina.\nKüsimuste korral võtke julgelt ühendust.\n\nTervitades,\nBioforce",
  },
];

// Tokens offered by the insert buttons in the editor.
export const TOKENS = [
  { token: "{klient}", label: "klient" },
  { token: "{objekt}", label: "objekt" },
  { token: "{periood}", label: "periood" },
  { token: "{kokku}", label: "kokku" },
];

export function fmtAmount(n) {
  return Number(n || 0).toLocaleString("et-EE", { maximumFractionDigits: 3 });
}

// Only known tokens are replaced — a typo like {peridood} stays visible on
// purpose, so it shows up in the preview instead of silently vanishing.
export function substituteTokens(text, ctx) {
  return String(text || "")
    .split("{klient}").join(ctx.klient || "")
    .split("{objekt}").join(ctx.objekt || "")
    .split("{periood}").join(ctx.periood || "")
    .split("{kokku}").join(ctx.kokku || "");
}

// The auto-generated block, split inbound / outbound.
export function buildSummaryBlock(inbound = [], outbound = []) {
  const lines = [];
  if (inbound.length === 0 && outbound.length === 0) return "";

  lines.push("Kokkuvõte sortimentide kaupa:");

  if (inbound.length > 0) {
    lines.push("");
    lines.push("Sisse:");
    inbound.forEach((a) => lines.push(`• ${a.sortiment}: ${fmtAmount(a.total)}`));
  }
  if (outbound.length > 0) {
    lines.push("");
    lines.push("Välja:");
    outbound.forEach((a) => lines.push(`• ${a.sortiment}: ${fmtAmount(a.total)}`));
  }
  return lines.join("\n");
}

/**
 * Assemble the final e-mail body: intro + summary + closing.
 * ctx: { klient, objekt, periood, kokku, inboundSummary, outboundSummary }
 */
export function buildEmailText(template, ctx) {
  const intro = substituteTokens(template?.intro || "", ctx);
  const closing = substituteTokens(template?.closing || "", ctx);
  const summary = buildSummaryBlock(ctx.inboundSummary, ctx.outboundSummary);

  return [intro, summary, closing].filter((p) => p && p.trim()).join("\n\n");
}

// Sample data for the editor preview (no real report is selected there).
export const SAMPLE_CTX = {
  klient: "Näidisklient OÜ",
  objekt: "Ebavere",
  periood: "07.07.2026 – 15.07.2026",
  kokku: "3 854,2",
  inboundSummary: [{ sortiment: "Veiseläga m3", total: 530 }],
  outboundSummary: [{ sortiment: "Digestaat m3", total: 3324.2 }],
};
